import useMobileView from '../../../hooks/useMobileView';
import { ArrowIconButton } from './ArrowIconButton';
import { CloseIconButton } from './CloseIconButton';

export interface AsideNavigationItemButton {
	isMainNaviElement?: boolean;
	naviBlockIsOpen?: boolean;
	setNaviBlockIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
	naviSectionIsOpen?: boolean;
	setNaviSectionIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AsideNavigationItemButton = ({
	isMainNaviElement,
	naviBlockIsOpen,
	setNaviBlockIsOpen,
	naviSectionIsOpen,
	setNaviSectionIsOpen,
}: AsideNavigationItemButton) => {
	const isMobile = useMobileView(900);
	const buttonClassNames = `items-center justify-center w-10 h-10 rounded-sm ${isMainNaviElement ? 'bg-secondary-yellow' : ''} p-2`;

	if (!isMobile) {
		if (!naviSectionIsOpen) {
			return (
				<ArrowIconButton
					direction={'right'}
					onClick={() => {
						if (setNaviSectionIsOpen) setNaviSectionIsOpen(true);
					}}
					className={buttonClassNames}
				/>
			);
		}
		return (
			<ArrowIconButton
				direction={'down'}
				onClick={() => {
					if (setNaviSectionIsOpen) setNaviSectionIsOpen(false);
				}}
				className={buttonClassNames}
			/>
		);
	}

	if (naviSectionIsOpen === false || (isMainNaviElement && !naviBlockIsOpen)) {
		return (
			<ArrowIconButton
				direction="down"
				className={buttonClassNames}
				onClick={() => {
					if (setNaviBlockIsOpen) setNaviBlockIsOpen(true);
					if (setNaviSectionIsOpen) setNaviSectionIsOpen(true);
				}}
			/>
		);
	}

	if (isMainNaviElement && naviBlockIsOpen) {
		return (
			<CloseIconButton
				className={buttonClassNames}
				onClick={() => {
					if (setNaviBlockIsOpen) return setNaviBlockIsOpen(false);
				}}
			/>
		);
	}

	return (
		<ArrowIconButton
			direction="up"
			className={`${buttonClassNames}`}
			onClick={() => {
				if (setNaviSectionIsOpen) return setNaviSectionIsOpen(false);
			}}
		/>
	);
};
